import React from 'react';

// Using React.lazy for code splitting (Vite equivalent of next/dynamic)
export const HeartRateChart = React.lazy(() => import('./HeartRateChart'));
export const HeartRateZonesChart = React.lazy(() => import('./HeartRateZonesChart'));
export const LocationStatsChart = React.lazy(() => import('./LocationStatsChart'));
